import { render, staticRenderFns } from "./PhLaunchBadge.vue?vue&type=template&id=1abe9187"
import script from "./PhLaunchBadge.vue?vue&type=script&lang=js"
export * from "./PhLaunchBadge.vue?vue&type=script&lang=js"
import style0 from "./PhLaunchBadge.vue?vue&type=style&index=0&id=1abe9187&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1abe9187')) {
      api.createRecord('1abe9187', component.options)
    } else {
      api.reload('1abe9187', component.options)
    }
    module.hot.accept("./PhLaunchBadge.vue?vue&type=template&id=1abe9187", function () {
      api.rerender('1abe9187', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ph-launch-badge/PhLaunchBadge.vue"
export default component.exports